export const APARTMENT_MODULE_NAMESPACE = 'apartment';
export const APARTMENT_LOADING = 'APARTMENT_LOADING';
export const APARTMENT_GET_APPARTMENTS_MASTER = 'APARTMENT_GET_APPARTMENTS_MASTER';
export const APARTMENT_SET_APPARTMENTS_MASTER = 'APARTMENT_SET_APARTMENTS';
export const APARTMENT_GET_APPARTMENTS = 'APARTMENT_GET_APPARTMENTS';
export const APARTMENT_SET_APPARTMENTS = 'APARTMENT_SET_APPARTMENTS';
export const APARTMENT_EXTEND_APARTMENTS = 'APARTMENT_EXTEND_APARTMENTS'
export const APARTMENT_UPDATE_APARTMENTS = 'APARTMENT_UPDATE_APARTMENTS'
export const APARTMENT_SET_BLOCK_APPARTMENTS = 'APARTMENT_SET_BLOCK_APPARTMENTS';
export const APARTMENT_GET_APPARTMENT = 'APARTMENT_GET_APPARTMENT';
export const APARTMENT_SET_APPARTMENT = 'APARTMENT_SET_APPARTMENT';
export const APARTMENT_SET_APARTMENT_BY_FIELD = 'APARTMENT_SET_APARTMENT_BY_FIELD'
export const APARTMENT_INIT_APPARTMENT = 'APARTMENT_INIT_APPARTMENT';
export const APARTMENT_RECORD_APPARTMENT = 'APARTMENT_RECORD_APPARTMENT';
export const APARTMENT_UPDATE_APARTMENT = 'APARTMENT_UPDATE_APARTMENT';
export const APARTMENT_DELETE_APARTMENT = 'APARTMENT_DELETE_APARTMENT';
export const APARTMENT_RESET_APPARTMENT = 'APARTMENT_RESET_APPARTMENT';
export const APARTMENT_RESET_APARTMENTS = 'APARTMENT_RESET_APARTMENTS';
export const APARTMENT_EDIT_APARTMENT = 'APARTMENT_EDIT_APARTMENT'
export const APARTMENT_RESET_APPARTMENTS= 'APARTMENT_RESET_APPARTMENTS';
export const APARTMENT_SET_PARAMETER = 'APARTMENT_SET_PARAMETER';
export const APARTMENT_GET_SIDEBAR_APPARTMENTS = 'APARTMENT_GET_SIDEBAR_APPARTMENTS';
export const APARTMENT_SET_SIDEBAR_APPARTMENTS = 'APARTMENT_SET_SIDEBAR_APPARTMENTS';
export const APARTMENT_EXTEND_SIDEBAR_APARTMENTS = 'APARTMENT_EXTEND_SIDEBAR_APARTMENTS'
export const APARTMENT_UPDATE_SIDEBAR_APARTMENTS = 'APARTMENT_UPDATE_SIDEBAR_APARTMENTS'
export const APARTMENT_SET_APPARTMENTS_PARAMETER_PARTIAL = 'APARTMENT_SET_APPARTMENTS_PARAMETER_PARTIAL';
export const APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE = 'APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE';
export const APARTMENT_GET_BLOCK_APPARTMENTS_AUTOCOMPLETE = 'APARTMENT_GET_BLOCK_APPARTMENTS_AUTOCOMPLETE';
export const APARTMENT_ACTION = 'APARTMENT_ACTION'
export const APARTMENT_SPLICE_APARTMENTS = 'APARTMENT_SPLICE_APARTMENTS'
export const APARTMENT_SPLICE_SIDEBAR_APARTMENTS = 'APARTMENT_SPLICE_SIDEBAR_APARTMENTS'
export const APARTMENT_RECORD_LOCATION_NUMBER = 'APARTMENT_RECORD_LOCATION_NUMBER';
export const APARTMENT_SET_LOCATION_NUMBER = 'APARTMENT_SET_LOCATION_NUMBER';
export const APARTMENT_SET_ZONE = 'APARTMENT_SET_ZONE';
export const APARTMENT_GET_ZONE = 'APARTMENT_GET_ZONE';
export const APARTMENT_POST_ZONE = 'APARTMENT_POST_ZONE';
export const APARTMENT_PATCH_ZONE = 'APARTMENT_PATCH_ZONE';
export const APARTMENT_DELETE_ZONE = 'APARTMENT_DELETE_ZONE';
export const APARTMENT_SET_ZONE_ACTION = 'APARTMENT_SET_ZONE_ACTION';
export const APARTMENT_SEARCH_ZONE = 'APARTMENT_SEARCH_ZONE';



// WEBPACK FOOTER //
// ./src/store/apartment/apartment-types.store.ts